var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"image-viewer"},[_c('canvas',{attrs:{"id":"canvas"}}),(_vm.loading)?_c('div',{staticClass:"image-viewer__loader"},[_c('Loading',{attrs:{"visible":true}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }